import script from "./TranslateCaptionSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslateCaptionSelector.vue?vue&type=script&setup=true&lang=js"

import "./TranslateCaptionSelector.vue?vue&type=style&index=0&id=07045d30&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07045d30"]])

export default __exports__